<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules")
  span.readonly-mode-field(v-if="isReadMode") {{ numberStr }}
  template(v-else)
    el-input-number.full-width-input(
      v-format-number="fieldModel",
      ref="fieldEditor",
      v-bind="inputBind",
      v-model="fieldModel",
      :class="numberClass",
      @focus="handleFocusCustomEvent",
      @blur="handleBlurCustomEvent",
      @change="handleChangeEvent"
    )
</template>
<script>
import { staticMixins } from "@/CommonDP/VForm/utils";
import { format, getNumString } from "./directive";
export default {
  directives: { formatNumber: format },
  mixins: [staticMixins],
  data() {
    return { showMask: true };
  },
  computed: {
    numberStr() {
      const {
        fieldModel,
        options: { prefix, suffix, precision }
      } = this;
      return `${prefix ?? ""} ${getNumString(fieldModel || 0, precision)} ${suffix ?? ""}`;
    },
    numberClass() {
      const {
        options: { formatNum }
      } = this;
      return {
        "no-format": !formatNum
      };
    },
    inputBind() {
      const {
        options: { controlsPosition, controls, disabled, placeholder, min, max, precision, prefix, suffix, step }
      } = this;
      return { controlsPosition, disabled, placeholder, controls, min, max, precision, prefix, suffix, step };
    }
  },
  methods: {
    // 取消 设计状态时修改阻止
    preventDesign() {},
    preventPreview() {}
  }
};
</script>
<style lang="scss" scoped >
.full-width-input {
  display: block;
  width: 100%;
}
</style>
